import { Link } from "react-router-dom";

const REQUIREMENTS = [
  ["Referral", "An existing member names you. We verify the introduction directly."],
  ["Accreditation", "Directed only to accredited investors in jurisdictions where no licence is required to transact in private securities."],
  ["Verification first", "Identity and documents are settled before any deal is shown. The clock starts at allocation, not at onboarding."],
  ["Discretion", "Your links are issued to you and are not transferable. Nothing about you is published anywhere, at any point."],
];

export default function MembershipProtocol() {
  return (
    <section className="hairline py-16 grid lg:grid-cols-2 gap-16 rise" data-testid="membership-protocol">
      <div>
        <span className="t-label">Membership</span>
        <h2 className="text-bone mt-4" style={{ fontSize: "clamp(22px, 2.6vw, 30px)", lineHeight: 1.3, fontWeight: 400 }}>
          Small on purpose. One referral, one member, one link.
        </h2>
        <p className="t-small text-muted-s mt-5 measure">
          We would rather have a hundred members who read the memos than ten thousand who
          read a feed. Members who circulate a memo outside the membership are removed. That
          has happened once, and it will happen again.
        </p>
        <div className="mt-8 flex gap-3 flex-wrap">
          <Link to="/register" className="btn-primary inline-block" data-testid="membership-register-button">Complete a referral</Link>
          <Link to="/login" className="btn-ghost inline-block" data-testid="membership-login-button">Already a member</Link>
        </div>
      </div>
      <div data-testid="membership-protocol-card">
        <span className="t-label">What membership requires</span>
        <div className="mt-4 space-y-0">
          {REQUIREMENTS.map(([k, v]) => (
            <div key={k} className="hairline py-4 flex gap-6">
              <span className="t-label w-44 shrink-0 whitespace-nowrap">{k}</span>
              <span className="t-small text-muted-s">{v}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
